<template>
  <div :class="['location-autocomplete field-group', {'field-error':!!error}]">
    <div style="display:none;">
      <input type="text">
      <input type="password">
    </div>
    <input type="text" ref="input" autocomplete="disabled" v-model="keyInput"
      :name="extra.field" :readonly="readOnly" :placeholder="extra.placeholder"
      :disabled="disabled || locationLoading" v-if="isIosDevice"
      @keypress="query" @blur="onBlur" @focus="onFocus" @keydown.tab="onpressTab"
      v-on:blur="clickOut" @click="onClick"
      :class="['location-input field-text', {'loading':locationLoading, 'has-error':!!error, 'move-left':((extra.field === 'pickup' && !extraStop[leg].length && extra.hasExtraStop) || extra.field === 'extraStop') && !isLyftBooking}]" />
    <input
      type="text" ref="input" autocomplete="disabled" v-model="keyInput"
      :name="extra.field" :readonly="readOnly" :placeholder="extra.placeholder"
      :disabled="disabled || locationLoading" v-if="!isIosDevice"
      @keyup="query" @blur="onBlur" @focus="onFocus" @keydown.tab="onpressTab"
      v-on:blur="clickOut" @click="onClick"
      :class="['location-input field-text', {'loading':locationLoading, 'has-error':!!error, 'move-left':((extra.field === 'pickup' && !extraStop[leg].length && extra.hasExtraStop) || extra.field === 'extraStop') && !isLyftBooking}]"
    />
    <span class="field-error-message">{{ error }}</span>
    <div class="add-stop" @click="toggleExtraStop(extra.field)"
      v-if="extra.field === 'pickup' && !extraStop[leg].length && !disabled && extra.hasExtraStop && !isLyftBooking">
      <i class="fas fa-plus" @mouseover="extraStopHover = true" @mouseleave="extraStopHover = false"></i>
      <transition name="slide-up">
        <span v-show="extraStopHover">{{ $t('searchForm.youCanAdd') }}</span>
      </transition>
    </div>
    <div class="add-stop" @click="toggleExtraStop(extra.field)"
      v-if="extra.field === 'extraStop' && extraStop[leg].length && !disabled && !isLyftBooking">
      <i class="fas fa-minus"></i>
    </div>
    <i :class="['fa fa-spinner fa-spin loaderx fa-2x', {'move-left':(extra.field === 'pickup' && !extraStop[leg].length && extra.hasExtraStop) || extra.field === 'extraStop'}]" v-show="locationLoading"></i>
    <transition name="slide-down">
      <ul class="location-suggestions" v-show="showSuggestion">
        <li v-for="(item, index) in suggestions" @click="selectLocation(index)"
          :class="{'empty':item.title === 'Sorry', 'select-item':index === selectIndex}"
          :key="index">
          <i v-bind:class="['fas', item.icon]"></i>
          <span v-html="item.subtitle || item.title"></span>
        </li>
      </ul>
    </transition>
    <transition name="slide-down">
      <ul class="static-location" v-show="showStaticLocations && focusing && lastLoc.length">
        <li v-for="(loc, i) in lastLoc" :key="i" @click="selectLoc(loc)">
          <i class="fas fa-clock"></i> {{ loc.title }}
        </li>
        <!-- <li @click="showStaticLocationModal('airports')">
          <i class="fas fa-plane"></i>{{ $t('searchForm.airports') }}
        </li> -->
        <!-- <li @click="showStaticLocationModal('hilton')" v-if="isMasimo">
          <i class="fas fa-location-arrow"></i>Hilton
        </li> -->
        <!-- <li @click="showStaticLocationModal('themeParks')" v-if="!isMasimo">
          <i class="fab fa-fort-awesome"></i>{{ $t('searchForm.themeParks') }}
        </li>
        <li @click="showStaticLocationModal('ports')" v-if="!isMasimo">
          <i class="fas fa-map-marker-alt"></i>{{ $t('searchForm.ports') }}
        </li>
        <li @click="showStaticLocationModal('hotels')" v-if="!isMasimo">
          <i class="fas fas fa-building"></i>{{ $t('searchForm.hotel') }}
        </li>
        <li @click="showStaticLocationModal('universities')" v-if="!isMasimo">
          <i class="fas fa-graduation-cap"></i>{{ $t('searchForm.universities') }}
        </li>
        <li @click="showMapModal()" v-if="!isMasimo">
          <i class="fas fa-map"></i>{{ $t('searchForm.setMap') }}
        </li> -->
      </ul>
    </transition>

    <static-location-modal ref="staticLocations" :field="extra.field" :id="id"
      @select="selectFromStaticLocations"></static-location-modal>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import StaticLocationModal from './StaticLocationModal'
import { setTimeout } from 'timers';

export default {
  name: 'location-input',
  props: ['value', 'extra', 'placeId', 'disabled', 'error', 'id', 'leg', 'noCommit'],
  components: { StaticLocationModal },
  data () {
    return {
      keyInput: this.value,
      autocomplete: '',
      geocoder: '',
      suggestions: [],
      showSuggestion: false,
      locationLoading: false,
      clickOutDelay: '',
      lastSelected: {},
      showStaticLocations: false,
      selectIndex: -1,
      windowInactive: false,
      isIosDevice: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      showOnLoad: true,
      focusing: false,
      readOnly: true,
      extraStopHover: false,
      isMasimo: false,
      lastLoc: []
    }
  },
  computed: {
    brandCode () { return this.$store.state.brandCode },
    brandId () { return this.$store.state.brandId },
    route () { return this.$route.name },
    reservation () { return this.$store.state.reservation },
    leg1Asap () { return this.reservation.leg1.isAsap },
    isLyftBooking () { return this.leg1Asap || this.reservation.lyft.enabled },
    extraStop () { return this.reservation.extraStop },
    d2d () { return this.reservation.d2d },
    other () { return this.$store.state.other }
  },
  methods: {
    onClick () {
      this.$emit('clickFocus', this.extra.field)
      if (this.keyInput && this.keyInput.trim()) {
        // this.query()
      }
    },
    onpressTab () {
      if (this.selectIndex > -1) {
        this.selectLocation(this.selectIndex)
        this.selectIndex = -1
      }
    },
    query (event) {
      let self = this

      let controls = ['ArrowDown', 'ArrowUp', 'Enter']
      if (event && controls.indexOf(event.key) > -1) {
        switch (event.key) {
          case 'ArrowDown':
            self.selectIndex++
            break
          case 'ArrowUp':
            if (self.selectIndex > -1) { self.selectIndex-- }
            break
          case 'Enter':
            if (self.selectIndex > -1) {
              self.selectLocation(self.selectIndex)
              self.selectIndex = -1
            } else { self.$emit('submit', self.leg) }
            break
        }
        return
      }

      self.selectIndex = -1
      self.showStaticLocations = self.keyInput === ''

      if (!self.autocomplete) {
        if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
          setTimeout(function () {
            let container = document.getElementsByClassName('pac-container')[0]
            container.addEventListener('touchend', function (e) {
              e.stopImmediatePropagation()
            })
          }, 500)
        }
      }

      self.$emit('change', {
        field: self.extra.field,
        keyInput: self.keyInput || '',
        blurStop: true,
        id: self.id || 0,
        leg: self.leg
      })

      let queryText = self.keyInput
      if (!queryText) {
        self.suggestions = []
        self.showSuggestion = false
        return
      }

      self.showSuggestion = true
      const restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]

      let suggestedLoc = { lat: 33.942791, lng: -118.410042 } // LAX
      let pickup = self.$store.state.reservation[self.leg].pickup
      if (['extraStop', 'dropoff'].indexOf(self.extra.field) > -1 && pickup.lat) {
        suggestedLoc = { lat: pickup.lat, lng: pickup.lng }
      }

      if (queryText.length >= 3) {
        let url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US'
        url = url.replace('{AT}', encodeURIComponent(suggestedLoc.lat + ',' + suggestedLoc.lng))
          .replace('{SEARCH}', queryText)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          if (err || body.items.length === 0) {
            self.suggestions = [{
              icon: 'fa-exclamation-triangle',
              title: self.$t('searchForm.sorry'),
              subtitle: `${self.$t('searchForm.coudntLocate')} ${queryText}`
            }]
            return
          }

          let result = []
          body.items.forEach(function (prediction) {
            if (restrictedTypes.indexOf(prediction.resultType) === -1) {
              // if (prediction.categories && (
                //   (prediction.categories[0].name.toLowerCase().indexOf('airport') > -1 && self.extra.type === 'd2d') ||
                //   (prediction.categories[0].name.toLowerCase().indexOf('airport') === -1 && self.extra.type === 'flight')
                // )) return
              let subtitle = prediction.address.label
              let icon = 'fa-map-marker'
              if (prediction.categories && prediction.categories.length && prediction.categories[0].name.toLowerCase().indexOf('airport') > -1) {
                icon = 'fa-plane'
              }
              result.push({
                id: prediction.id,
                title: prediction.title,
                subtitle: subtitle,
                icon: icon
              })
            }
          })

          self.suggestions = result.slice(0, 5)
        })
      }
    },
    selectLocation (index, extPlaceId = null) {
      let self = this
      let place = self.suggestions[index]
      let placeId = extPlaceId || place.id

      if (self.locationLoading || !placeId) { return }
      clearTimeout(this.clickOutDelay)
      self.showSuggestion = false
      self.locationLoading = true

      let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US'
      url = url.replace('{LOCATION_ID}', placeId)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.locationLoading = false
          return
        }

        let result = body
        let lat = result.position.lat
        let lng = result.position.lng
        let finalResult = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        }

        self.keyInput = finalResult.title
        self.lastSelected = finalResult

        let isAirport = false
        if (body.categories) {
          body.categories.forEach(cat => {
            if (cat.name && cat.name.toLowerCase().indexOf('airport') > -1) isAirport = true
          })
        }
        finalResult.isAirport = isAirport
        console.log('no commit', self.noCommit)
        if (self.noCommit) {
          self.$emit('isAirportVal', {
            field: self.extra.field,
            data: { leg: 'leg1', value: isAirport }
          })
        } else {
          // if (self.other.widgetTab === 'ground') {
          let tmpStoreCommit = self.extra.field === 'pickup' ? 'reservation/setIsAirportPickup' : 'reservation/setIsAirportDropoff'
          self.$store.commit(tmpStoreCommit, {
            leg: 'leg1',
            value: isAirport
          })
          // } else {
          //   let tmpIsAirport = {}
          //   tmpIsAirport[self.extra.field === 'pickup' ? 'isAirportPickup' : 'isAirportDropoff'] = isAirport
          //   self.$store.commit('booking/setLocationsData', tmpIsAirport)
          // }
        }

        let locationType = self.extra.field.charAt(0).toUpperCase() + self.extra.field.substr(1)
        if (self.extra.field === 'charter') {
          self.$store.commit('reservation/setCharterData', {pickup: finalResult})
          self.$store.commit('reservation/setPickup', {
            leg: 'leg1',
            value: finalResult
          })
        } else if (self.extra.field === 'extraStop') {
          self.$store.commit('reservation/setExtraStopLocationData', {
            leg: self.leg,
            id: self.id,
            value: finalResult
          })
        } else {
          if (self.noCommit) {
            self.$emit('locationVal', {
              field: self.extra.field,
              data: { leg: self.leg, value: finalResult }
            })
          } else {
            // if (self.other.widgetTab === 'ground') {
            self.$store.commit('reservation/set' + locationType, {
              leg: self.leg,
              value: finalResult
            })
            // } else {
            //   let tmpLoc = {}
            //   tmpLoc[self.extra.field] = finalResult
            //   self.$store.commit('booking/setLocationsData', tmpLoc)
            // }
          }
        }
        if (self.extra.field === 'pickup') {
          if (self.noCommit) {
            self.$emit('airportSortListVal', { lat: lat, lng: lng })
          } else {
            self.$store.commit('airports/sortList', { lat: lat, lng: lng })
          }
        }

        self.$emit('change', {
          field: self.extra.field,
          keyInput: self.keyInput || '',
          id: self.id || 0,
          leg: self.leg,
          check: true,
          isAirport: isAirport
        })
        self.$emit('nextFocus')
        self.locationLoading = false
        if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
          let field = self.extra.field.charAt(0).toUpperCase() + self.extra.field.slice(1)
          gtag('event', `Flight Booking - ${field} Location`, { // eslint-disable-line
            // category: 'Custom',
            value: self.keyInput
          })
        }
      })
    },
    clickOut () {
      let self = this
      self.clickOutDelay = setTimeout(function () {
        self.$emit('change', {
          field: self.extra.field,
          keyInput: self.keyInput || '',
          id: self.id || 0,
          leg: self.leg
        })
        self.showSuggestion = false
      }, 200)
    },
    focus () {
      let self = this
      self.$nextTick(function () { self.$refs.input.focus() })
    },
    onFocus () {
      this.focusing = true
      if (!this.keyInput) this.showStaticLocations = true
    },
    onBlur () {
      this.focusing = false
      this.showStaticLocations = false
    },
    showStaticLocationModal (x) {
      if (this.$refs.staticLocations.showModal(x)) { this.$refs.staticLocations.showModal(x) }
    },
    showMapModal () {
      if (screen.width > 640) {
        document.body.classList.add('widget-no-scroll')
      } else {
        window.fcWidget.hide()
        document.body.classList.add('widget-full')
      }
      let self = this
      self.$store.commit('setShowMapModal', {
        show: true,
        target: this.extra.field
      })
      self.$store.commit('reservation/setMapData', {init: true})
    },
    selectFromStaticLocations (value) {
      this.keyInput = value.keyInput
      this.$emit('change', {
        field: value.field,
        keyInput: value.keyInput,
        id: this.id || 0,
        leg: this.leg
      })
      this.$emit('nextFocus')
    },
    checkShowOnLoad () {
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad
      }
    },
    toggleExtraStop (field) {
      let self = this
      if (field === 'pickup') {
        this.$store.commit('reservation/addExtraStop', {
          leg: this.leg,
          value: {
            id: moment().format('x'),
            value: '',
            text: '',
            extra: {
              field: 'extraStop',
              placeholder: self.$t('searchForm.locationPlaceholder')
            },
            placeId: '',
            location: {},
            error: ''
          }
        })
        self.$nextTick(function () {
          self.$emit('focusOnNewExtra')
        })
      } else if (this.id) {
        self.$store.commit('reservation/removeExtraStop', {
          leg: this.leg,
          id: this.id
        })
        if (this.leg === 'leg1' && !self.$store.state.reservation.isRoundtrip) {
          self.$store.commit('reservation/removeExtraStop', {
            leg: 'leg2',
            id: this.id
          })
        }
      }
    },
    selectLoc (data) {
      this.keyInput = data.title
      this.$emit('change', {
        field: this.extra.field,
        keyInput: data.title,
        leg: 'leg1'
      })

      if (this.leg === 'leg1') {
        let tmpIsAirport = {}
        tmpIsAirport[this.extra.field === 'pickup' ? 'isAirportPickup' : 'isAirportDropoff'] = data.geofenceType === 'airport'
        this.$store.commit('booking/setLocationsData', tmpIsAirport)
      }

      if (this.noCommit) {
        this.$emit('locationVal', {
          field: this.extra.field,
          data: { leg: 'leg1', value: data }
        })
      } else {
        // if (this.other.widgetTab === 'ground') {
        let commit = this.extra.field === 'pickup' ? 'setPickup' : 'setDropoff'
        this.$store.commit(`reservation/${commit}`, {
          leg: 'leg1',
          value: data
        })
        // } else {
        //   let tmpLoc = {}
        //   tmpLoc[this.extra.field] = data
        //   this.$store.commit('booking/setLocationsData', tmpLoc)
        // }
        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            this.extra.field === 'pickup' ? 'Flight Booking - Pickup Location' : 'Flight Booking - Dropoff Location',
            {value: data.title}
          )
        }
      }
      this.$emit('change', {
        field: this.extra.field,
        keyInput: data.title,
        leg: 'leg1',
        check: true,
        isAirport: data.isAirport
      })
      this.$emit('nextFocus')
    }
  },
  watch: {
    value: function (value) {
      this.keyInput = value
    },
    placeId: function (placeId) {
      this.selectLocation(-1, placeId)
    },
    extra: function (value) {
      if (!value.disabled) {
        // let locationType = this.extra.field.charAt(0).toUpperCase() + this.extra.field.substr(1)
        if (Object.keys(this.lastSelected).length) {
          // this.$store.commit('reservation/set' + locationType, {
          //   leg: 'leg1',
          //   value: this.lastSelected
          // })
        }
      }
    }
  },
  mounted: function () {
    let self = this
    window.onblur = function () {
      self.windowInactive = true
    }

    setTimeout(function () {
      if (self.extra.field === 'pickup' && !self.value && !self.showOnLoad) {
        self.focus()
      }

      // for anti chrome autofill
      self.readOnly = false
      self.$nextTick(function () {
        self.readOnly = true
        self.readOnly = false
      })
    }, 500)

    if (localStorage.getItem('lastPickupLoc')) {
      let pickup = JSON.parse(localStorage.getItem('lastPickupLoc'))
      if (!localStorage.getItem('fixLastPickupLoc') && Object.keys(pickup).indexOf('isAirport') > -1 || localStorage.getItem('fixLastPickupLoc')) {
        self.lastLoc.push(pickup)
      }
    }
    if (localStorage.getItem('lastDropoffLoc')) {
      let dropoff = JSON.parse(localStorage.getItem('lastDropoffLoc'))
      if (!localStorage.getItem('fixLastDropoffLoc') && Object.keys(dropoff).indexOf('isAirport') > -1 || localStorage.getItem('fixLastDropoffLoc')) {
        self.lastLoc.push(dropoff)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.location-input {
  webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.location-autocomplete {
  position: relative;
  width: 100%;
}

.location-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  max-height: 150px;
  list-style: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  margin: 0;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  z-index: 3;

  li {
    background: #f6f6f6;
    padding: 8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #bbb;
    color: #333;

    &:last-child {
      border-bottom: none;
    }
    i {
      margin-right: 5px;
      width: 20px;
      text-align: center;
    }
    span {
      font-size: 13px;
    }
    .fa-exclamation-triangle {
      color: #e2c84a;
    }
    .fa-map-marker {
      color: #ea5c5c;
    }
    &:hover,
    &.select-item {
      background: #0d79f2;
      color: #fff;

      i {
        color: #fff;
      }
    }
    &.empty {
      cursor: default;
    }
  }
}

.location-input {
  margin: 0;
  color: #333;
  line-height: inherit;
  transition: all 0.15s ease;
  width: 100%;
  position: relative;
  z-index: 1;

  &.loading {
    padding-right: 40px;
  }
  &.has-error {
    border-color: #f20d0d;
  }
  &:disabled {
    background: #eee;
  }
  &.move-left{
    width: calc(100% - 36px);
  }
}

.add-stop{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  border:1px solid #ccc;
  background: #fff;
  cursor: pointer;
  box-shadow: -2px 0 3px rgba(0,0,0, .1);

  i{
    font-size: 18px;
    padding: 10px;
    color: #465a87;
  }
  span{
    background: #e1e1e1;
    padding: 8px;
    position: absolute;
    bottom: calc(100% + 25px);
    box-shadow: 3px 3px 3px 0px #A3A3A3;
    color: #000;
    font-weight: 600;
    width: 250px;
    left: -105px;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;

    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 0;
      z-index: 1;
      border-style: solid;
      border-color: #e1e1e1 transparent;
      border-width: 20px 20px 0;
      bottom: -20px;
      left: 50%;
      margin-left: -20px;
    }
  }
}

.extra-stop {
  .location-input{
    width: calc(100% - 36px);
  }
}

.error-msg {
  font-size: 12px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
  display: block;
}

.loaderx {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 4;
  color: #bbb;

  &.move-left{
    right: 45px;
  }
}

.static-location {
  padding: 0;
  margin: 0;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  list-style: none;
  width: 100%;
  z-index: 2;
  height: 140px;
  overflow: auto;

  li {
    display: block;
    background: #f6f6f6;
    border: 1px solid #cbd2dc;
    padding: 5px 10px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:last-child {
      border-top: none;
    }
    &:hover {
      background: #0d79f2;
      color: #fff;
    }
  }
  i {
    margin-right: 5px;
  }
  .fa-fort-awesome {
    color: #f18538;
  }
  .fa-plane {
    color: #84a2bb;
  }
  .fa-map-marker-alt {
    color: #ff4d3b;
  }
  .fa-building {
    color: #91a2c7;
  }

  .fa-map {
    color: #79c41c;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-out;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-out;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// LocationInput.vue?63f5f1c4